module.exports = require('./helpers/bundle-url').getBundleURL('58NtB') + "logo.c51670a8.svg";